// ######################### Fishbone Direction #########################
export const fishboneDirection_Horizontal = 'horizontal';
export const fishboneDirection_Vertical = 'vertical';
export const fishboneDirections = [fishboneDirection_Horizontal, fishboneDirection_Vertical];
//# sourceMappingURL=types.js.map